<template>
  <div id="app">
    <member-header @cancel="cancelDialogHandle"></member-header>
    <div id="member_main">
      <main>
        <transition name="page" mode="out-in">
          <router-view></router-view>
        </transition>
      </main>
    </div>

    <el-dialog title="お申込みのキャンセル" :visible.sync="cancelDialog" width="80%">
      <span>お申込みをキャンセルしてよろしいでしょうか？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog = false">戻る</el-button>
        <el-button type="danger" @click="nextCancelPage">キャンセルする</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MemberHeader from './member/header.vue'
export default {
  name: 'app',
  data() {
    return {
      cancelDialog: false
    }
  },
  components: {
    MemberHeader
  },
  created() {
    this.$store.dispatch('auth/checkLogin')
    if (!this.$store.getters['auth/isLogin']) {
      this.$router.push({name: 'login'})
    }
  },
  methods: {
    cancelDialogHandle() {
      this.cancelDialog = true
    },
    nextCancelPage() {
      this.cancelDialog = false
      this.transitionSame('cancel')
    }
  }
}
</script>
<style lang="scss">
.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.page-enter,
.page-leave-to {
  opacity: 0;
  transform: translateY(5%);
}
#member_main {
  margin-top: 70px;
}
</style>
